export const PO_BOX_ADDRESS = {
  message:
    'We can’t ship to a P.O. Box. Please enter a physical shipping address.',
};

export const FIRST_NAME_REQUIRED = {
  message: 'Please enter a first name.',
};

export const FIRST_NAME_INVALID = {
  message: `We only allow letters (a-z), numbers and the following symbols: ' . -`,
};

export const LAST_NAME_REQUIRED = {
  message: 'Please enter a last name.',
};

export const LAST_NAME_INVALID = {
  message: `We only allow letters (a-z), numbers and the following symbols: ' . -`,
};

export const ADDRESS_NICK_NAME_INVALID = {
  message:
    'We only allow letters (a-z), numbers and the following symbols: &*#();-@/."',
};

export const PHONE_REQUIRED = {
  message: 'Please provide a 10-digit phone number.',
};

export const COMPANY_NAME_INVALID = {
  message:
    'We only allow letters (a-z), numbers and the following symbols: &*#();-@/.',
};

export const COMPANY_NAME_TOO_LONG = {
  message: "Company Name can't exceed 100 characters.",
};

export const SHIPPING_ADDRESS_INVALID = {
  message: 'Please provide a valid shipping address.',
};

export const ZIP_CODE_REQUIRED = {
  message: 'Please provide a 5-digit ZIP code.',
};

export const ZIP_CODE_INVALID = {
  message: 'Please provide a valid ZIP code.',
};

export const CARD_HOLDER_NAME_REQUIRED = {
  message: 'Please enter the name that appears on the card.',
};

export const CARD_BILLING_ADDRESS_REQUIRED = {
  message: 'Please provide a billing address.',
};

export const CARD_EXP_MONTH_REQUIRED = {
  message: 'Please provide a valid expiration date.',
};

export const CARD_EXP_YEAR_REQUIRED = {
  message: 'Please provide a valid expiration date.',
};

export const CARD_HOLDER_NAME_INVALID = {
  message: 'We only allow letters (a-z), space and the following symbols: _-.',
};

export const CARD_HOLDER_NAME_TOO_LONG = {
  message: "Name on card can't be longer than 100 characters.",
};

export const BILLING_ADDRESS_INVALID = {
  message: 'Please provide a valid billing address.',
};

export const CARD_NICKNAME_INVALID = {
  message: 'Please provide a valid card nickname.',
};

export const GIFT_CARD_ENOUGH_DIGITS = {
  message: 'Please provide the entire 23-digit gift card number.',
};

export const GIFT_CARD_REQUIRED = {
  message: 'Please enter a valid gift card number.',
};

export const CHECKING_ACCOUNT_NUMBER_INVALID = {
  message: 'Account numbers must have at least 4 digits.',
};

export const CHECKING_ACCOUNT_NUMBER_TOO_LONG = {
  message: "Account numbers can't exceed 18 digits.",
};

export const CHECKING_ACCOUNT_ROUTING_INVALID = {
  message: 'Routing numbers must have 9 digits.',
};

export const KEYTAG_NUMBER_INVALID = {
  message:
    "That doesn't seem to be a valid Keytag Number. Please try re-entering the number.",
};

export const NICKNAME_INVALID = {
  message:
    'We only allow letters (a-z), numbers and the following symbols: &_#.-$',
};

export const PHONE_INVALID = {
  message: 'Not a valid phone number. Please enter a valid phone number.',
};

export const NICKNAME_TOO_LONG = {
  message: "Nicknames can't exceed 50 characters",
};

export const ADDRESS_NICKNAME_TOO_LONG = {
  message: "Address Nickname can't exceed 50 characters",
};

export const CARD_LAST_4_INVALID = {
  message: 'Please enter the last 4 digits.',
};

export const CITI_SEARCH_INVALID = {
  message: 'Enter the last 4 digits of the Citi Account ID.',
};

export const EXPIRY_INVALID = {
  message: 'Enter a valid expiration date format as MM/YY.',
};

export const GIFT_CARD_PIN_INVALID = {
  message: 'PIN number must have 4 digits.',
};

export const GIFT_CARD_PIN_REQUIRED = {
  message: 'Please enter a valid gift card pin number.',
};

export const RECAPTCHA_REQUIRED = {
  message: 'Please confirm you are not a robot.',
};

export const FIRST_NAME_TOO_LONG = {
  message: "First name can't be longer than 40 characters.",
};

export const LAST_NAME_TOO_LONG = {
  message: "Last name can't be longer than 60 characters.",
};

export const CARD_ADDRESS_INVALID = {
  message: 'Please provide a valid billing address.',
};

export const CARD_ADDRESS_REQUIRED = {
  message: 'Please provide a billing address.',
};

export const CARD_NICKNAME_INVALID_ADD_CARD = {
  message:
    'We only allow letters (a-z), numbers and the following symbols: &_#.-$',
};

export const SECURITY_CODE_REQUIRED = {
  message: 'Please provide the security code.',
};

export const CARD_NUMBER_INVALID = {
  message: 'Please provide the entire card number.',
};

export const BILLING_ADDRESS_TOO_LONG = {
  message: 'Billing address can’t be longer than 60 characters.',
};

export const MOBILE_PHONE_REQUIRED = 'Please provide a mobile phone number.';

export const NO_REMOTE_PURCHASE_METHOD =
  'Please select a remote purchase approval method to proceed.';

export const NAME_REQUIRED = {
  message: 'Please enter a name.',
};

export const NAME_TOO_LONG = {
  message: "Name can't be longer than 40 characters.",
};

export const NAME_INVALID = {
  message:
    'We only allow letters (a-z), numbers and the following symbols: &*#();-@/."',
};

export const MIN_MA_REQUIRED = {
  message: 'Please add at least one more approver.',
};

export const MAX_MA_ALLOWED = {
  message: 'No more than 5 approvers are allowed.',
};

export const PHONE_NUMBER_NOT_UNIQUE = {
  message: 'This number is already in use. Please provide a different one.',
};
